<template>
  <div>
    <a-page-header style="width: 105%; margin-left: -20px" title="">
      <template slot="tags">
        <a-breadcrumb>
          <a-breadcrumb-item href="">
            <a-icon type="pie-chart"/>
            <span>{{ $t("message.memberCenter.memberCenter") }}</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="">
            <a-icon type="usergroup-add"/>
            <span>{{ $t("message.memberCenter.addRules") }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </template>
    </a-page-header>
    <a-spin :spinning="spinning">
      <a-card style="min-height: calc(100vh - 141px);">
        <div class="add-member-title mb16">{{ $t("message.memberCenter.pointEventLimitConfig") }}</div>
        <a-row>
          <a-col :md="{ span: 24 }" :lg="{ span: 13 }" :xl="{ span: 13 }" :xxl="{ span: 13 }">

            <div>
              <a-form-model ref="addFormRef" :model="form" :labelCol="{ span: 2 }"
                            :wrapperCol="{ span: 22 }" :rules="rules">
                <a-form-model-item :label="$t('message.orderCenter.materialType')"
                                   v-for="material in form.materialList"
                                   :key="material.id">
                  <div class="flex grid-gap-8 align-items-center">
                    <a-select :size="$globalSize" v-model="material.ruleCondition"  style="width: 200px;"
                              :placeholder="$t('message.orderCenter.materialTypePl')"
                              :options="materialTypeOpt">
                    </a-select>
                    <div>
                      {{ $t('message.orderCenter.subtitle') }}
                    </div>
                    <a-input-number :size="$globalSize" style="width: 150px;" v-model="material.value"  :min="1" :max="100000"/>
                    <a-popconfirm
                        :title="$t('message.commonUsage.deleteConfirmMsg')"
                        :ok-text="$t('message.commonUsage.confirm')"
                        :cancel-text="$t('message.commonUsage.cancel')"
                        @confirm="del(material)"
                    >
                      <div class="close-icon flex align-items-center justify-content-center cursor-pointer">
                        <a-icon type="close" style="font-size: 12px;color: white"/>
                      </div>
                    </a-popconfirm>
                  </div>
                </a-form-model-item>
              </a-form-model>
            </div>

            <div class="flex  grid-gap-8 align-items-center">
              <a-button  :size="$globalSize" 
                  
                  class="flex align-items-center justify-content-center grid-gap-12"
                  style="min-width: 120px;background: rgba(73, 176, 252, 0.2);color: rgba(0,0,0, 0.6);"
                  @click="add"
              >
                <a-icon type="plus" class="add-icon-gray" style="color:white;"/>
                {{ $t("message.commonUsage.add") }}
              </a-button>
              <div class="question-icon">
                <questionIcon></questionIcon>
              </div>
              <div class="sub-title-2">{{ $t("message.memberCenter.subtitle2") }}</div>
            </div>

          </a-col>
        </a-row>

        <a-divider></a-divider>
        <a-row>
          <a-col :md="{ span: 24 }" :lg="{ span: 8 }" :xl="{ span: 8 }" :xxl="{ span: 8 }">
            <div class="flex grid-gap-16 ">
              <a-button  :size="$globalSize"  class="form-submit-btn"  @click="showModal">{{
                  $t('message.commonUsage.confirm')
                }}
              </a-button>
              <a-button  :size="$globalSize"  class="form-cancel-btn"  @click="$emit('close')">{{ $t('message.commonUsage.cancel') }}</a-button>
            </div>
          </a-col>
        </a-row>
      </a-card>
    </a-spin>

    <a-modal
        :title="$t('message.commonUsage.addConfirmTitle')"
        :visible="visible"
        @cancel="handleCancel"
        :footer="null"
        centered
        :bodyStyle="{'padding-left':'24px'}"
    >
      <div class="confirm-modal-body w100 flex justify-content-center align-items-center">
        {{ $t('message.commonUsage.addConfirmContent') }}
      </div>
      <div class="w100 flex justify-content-center grid-gap-16 mt24">
        <a-button  :size="$globalSize"  class="form-submit-btn"  @click="handleOk" :loading="confirmLoading">{{
            $t('message.commonUsage.confirm')
          }}
        </a-button>
        <a-button  :size="$globalSize"  class="form-cancel-btn"  @click="handleCancel">{{
            $t('message.commonUsage.cancel')
          }}
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {questionIcon} from '@/components/richIcon/index'
import integralRuleApi from "@/interface/pages/memberCenter/integralRuleApi";

export default {
  name: "OrderLimit",
  components: {
    questionIcon
  },
  data() {
    return {
      visible: false,
      spinning: false,
      confirmLoading: false,
      form: {

        materialList: []
      },
      rules: {},
      materialTypeOpt: [
        {
          label: '咖啡机',
          value: 'M'
        },
        {
          label: '胶囊',
          value: 'C'
        }
      ]
    }
  },
  mounted() {
    this.getOrderLimitList()
  },
  methods: {
    add() {
      this.form.materialList.push({
        factorId: "goods_type_name",
        operator: "gt",
      })
    },
    showModal(){
      if(this.form.materialList.length !== 0
          && this.form.materialList[this.form.materialList.length - 1].ruleCondition
          && this.form.materialList[this.form.materialList.length - 1].value){
        this.visible = true
      }else{
        this.$message.error(this.$t('message.orderCenter.subtitle1'))
      }
    },
    async del(record) {
      const {data: res} = await integralRuleApi.saveOrderLimitList(this, {
        data: this.form.materialList.filter(item => item.id !== record.id)
      })
      if (res.code === 0) {
        this.$message.success(this.$t('message.commonUsage.successfullySaved'))
        this.getOrderLimitList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async handleOk(e) {
      this.confirmLoading = true;
      const {data: res} = await integralRuleApi.saveOrderLimitList(this, {
        data: this.form.materialList
      })
      if (res.code === 0) {
        this.$message.success(this.$t('message.commonUsage.successfullySaved'))
        this.visible = false
        this.confirmLoading = false
      } else {
        this.$message.error(res.msg)
        this.confirmLoading = false
      }
    },
    handleCancel(e) {
      this.visible = false;
    },
    async getOrderLimitList() {
      const {data: res} = await integralRuleApi.getOrderLimitList(this, {})
      if (res.code === 0) {
        this.form.materialList = res.data
      } else {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style scoped lang="less">
.add-member-title {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.9);
}

.form-sub-title {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.6);
}


::v-deep .ant-modal-title {
  text-align: left;
}


.sub-title {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.6);

}

.sub-title-1 {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.6);
}

.sub-title-2 {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.6);

}

.close-icon {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.26);
}
</style>